var _rect, _path, _rect2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagUsa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 16",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "United States flag") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b22234",
    d: "M0 0h24v1.23H0zm0 2.46h24v1.23H0zm0 2.46h24v1.23H0zm0 2.46h24v1.23H0zm0 2.46h24v1.23H0zm0 2.46h24v1.23H0zm0 2.46h24V16H0z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 10.5,
    height: 8.62,
    fill: "#3c3b6e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.3,
    cy: 1.25,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 1.25,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.7,
    cy: 1.25,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.9,
    cy: 1.25,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.2,
    cy: 2.3,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4,
    cy: 3.1,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.6,
    cy: 3.1,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.8,
    cy: 3.1,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 3.1,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.3,
    cy: 4.95,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.5,
    cy: 4.95,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.7,
    cy: 4.95,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.9,
    cy: 4.95,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9.2,
    cy: 6,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.4,
    cy: 6.8,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.6,
    cy: 6.8,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6.8,
    cy: 6.8,
    r: 0.42
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 6.8,
    r: 0.42
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUsa);
export default __webpack_public_path__ + "static/media/flag-usa.881757026ced51d9549f78167efd72a9.svg";
export { ForwardRef as ReactComponent };